import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _browseTemplatesRequest = {};
var _browseTemplatesResponse = {};
var _getTemplateBySlugRequest = {};
var _getTemplateResponse = {};
var _resultMetadata = { score: 'google.protobuf.FloatValue' };
var _results = { templates: '_templateResult' };
var _searchTemplatesRequest = {};
var _searchTemplatesResponse = { results: '_results' };
var _templateResult = { metadata: '_resultMetadata' };
function resolveWixTemplatesApiViewV2TemplateViewServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/template-cms-view-service',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/template-cms-view-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/template-cms-view-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/template-cms-view-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Searches templates across all categories in the live book by query.
 * Returns a paged view of the results.
 * Mandatory params:
 * `language` - language in which to search for templates.
 */
export function searchTemplates(payload) {
    var _a = serializer(_searchTemplatesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchTemplatesResponse, {
        _resultMetadata: _resultMetadata,
        _results: _results,
        _templateResult: _templateResult,
    }).fromJSON;
    function __searchTemplates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.templates_gallery.v2.template',
            method: 'GET',
            methodFqn: 'wix.templates.api.view.v2.TemplateViewService.SearchTemplates',
            url: resolveWixTemplatesApiViewV2TemplateViewServiceUrl({
                protoPath: '/view/v2/templates/search',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchTemplates.fromReq = fromReq;
    return __searchTemplates;
}
searchTemplates.__isAmbassador = true;
/**
 * Suggest templates.
 * Returns a paged view of the results.
 * Mandatory params:
 * `language` - language in which to search for templates.
 */
export function suggestTemplates(payload) {
    var _a = serializer(_searchTemplatesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchTemplatesResponse, {
        _resultMetadata: _resultMetadata,
        _results: _results,
        _templateResult: _templateResult,
    }).fromJSON;
    function __suggestTemplates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.templates_gallery.v2.template',
            method: 'GET',
            methodFqn: 'wix.templates.api.view.v2.TemplateViewService.SuggestTemplates',
            url: resolveWixTemplatesApiViewV2TemplateViewServiceUrl({
                protoPath: '/view/v2/templates/suggest',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __suggestTemplates.fromReq = fromReq;
    return __suggestTemplates;
}
suggestTemplates.__isAmbassador = true;
/**
 * Returns templates of specified categories, with optional filtering & sorting.
 * Mandatory params:
 * `language` - language in which to search for templates.
 */
export function browseTemplates(payload) {
    var _a = serializer(_browseTemplatesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_browseTemplatesResponse, {}).fromJSON;
    function __browseTemplates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.templates_gallery.v2.template',
            method: 'GET',
            methodFqn: 'wix.templates.api.view.v2.TemplateViewService.BrowseTemplates',
            url: resolveWixTemplatesApiViewV2TemplateViewServiceUrl({
                protoPath: '/view/v2/templates/browse',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __browseTemplates.fromReq = fromReq;
    return __browseTemplates;
}
browseTemplates.__isAmbassador = true;
/**
 * Returns the template's data in the requested language.
 * The template is identified by its slug.
 *
 * Mandatory params:
 * `templateSlug` - slug of the category to return.
 * `language` - language in which to view the template.
 */
export function getTemplateBySlug(payload) {
    var _a = serializer(_getTemplateBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTemplateResponse, {}).fromJSON;
    function __getTemplateBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel.templates_gallery.v2.template',
            method: 'GET',
            methodFqn: 'wix.templates.api.view.v2.TemplateViewService.GetTemplateBySlug',
            url: resolveWixTemplatesApiViewV2TemplateViewServiceUrl({
                protoPath: '/view/v2/templates/slug/{templateSlug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTemplateBySlug.fromReq = fromReq;
    return __getTemplateBySlug;
}
getTemplateBySlug.__isAmbassador = true;
//# sourceMappingURL=http.impl.js.map